import houseFrontImg from "../assets/images/housefront.png";
import roofSlope from "../assets/images/roofslope.png";
import penetration from "../assets/images/penetration.png";
import ridgecap from "../assets/images/ridgecap.png";
import metalflashings from "../assets/images/metalflashings.png";

export interface ImageWithMetadata {
    url: string;
    assetId?: string;
    thumbAssetId?: string;
    previewAssetId?: string;
    note?: string | null;
}

export const roofingPhotoSections = [
    {
        id: "frontHouse",
        title: "Front of House",
        label: "TASK:INITIAL_INSPECTION:FHSA",
        description: "Capture a wide shot showing the address and the overall front view of the property.",
        coverImage: houseFrontImg,
    },
    {
        id: "slopeOverview",
        title: "Slope Overview",
        label: "TASK:INITIAL_INSPECTION:OOES",
        description: "Photos showing the condition and angles of each slope of the roof.",
        coverImage: roofSlope,
    },
    {
        id: "penetrationCloseups",
        title: "Penetrations",
        label: "TASK:INITIAL_INSPECTION:COEP",
        description: "Close-up shots of all roof penetrations, including vents, pipes, and other elements.",
        coverImage: penetration,
    },
    {
        id: "metalFlashings",
        title: "Metal Flashings",
        label: "TASK:INITIAL_INSPECTION:AMFL",
        description: "Images of all metal flashings used, including drip edge, step flashings, and more.",
        coverImage: metalflashings,
    },
    {
        id: "ridgeCapNails",
        title: "Ridge Cap Nails",
        label: "TASK:INITIAL_INSPECTION:RCNS",
        description: "Detailed photos showing the ridge cap nails and their proper sealing.",
        coverImage: ridgecap,
    },
];
